export default __webpack_public_path__ + "static/media/1.7b447c53.jpg";